import { SectionHeader } from "./SectionHeader";
import type { Theme } from "./theme";

const STEPS = [
  { n: "01", t: "Define", s: "Align stakeholders on what good looks like." },
  { n: "02", t: "Find", s: "Access the relevant talent market effectively." },
  { n: "03", t: "Assess", s: "Evaluate candidates using shared criteria." },
  { n: "04", t: "Compare", s: "Review candidates side-by-side with clarity." },
  { n: "05", t: "Decide", s: "Make confident, evidence-based decisions together." },
];

export function HowItWorks({ theme }: { theme: Theme }) {
  return (
    <section
      id="how"
      style={{
        padding: "120px 0",
        borderTop: `1px solid ${theme.border}`,
        background: theme.surface,
      }}
    >
      <SectionHeader
        theme={theme}
        kicker="How it works"
        title="A structured, collaborative approach to hiring."
      />
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 40px" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            position: "relative",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 24,
              left: 40,
              right: 40,
              height: 1,
              background: theme.border,
            }}
          />
          {STEPS.map((s, i) => (
            <div key={s.n} style={{ padding: "0 16px", position: "relative", textAlign: "left" }}>
              <div
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: 24,
                  background: theme.bg,
                  border: `1px solid ${theme.border}`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontFamily: theme.mono,
                  fontSize: 13,
                  color: theme.fg,
                  fontWeight: 500,
                  marginBottom: 20,
                  position: "relative",
                }}
              >
                {s.n}
                {i === 0 && (
                  <span
                    style={{
                      position: "absolute",
                      inset: -4,
                      borderRadius: 28,
                      border: `1.5px solid ${theme.accent}`,
                      animation: "rarionPulse 2s ease-out infinite",
                    }}
                  />
                )}
              </div>
              <div
                style={{
                  fontSize: 20,
                  fontWeight: 600,
                  color: theme.fg,
                  letterSpacing: -0.4,
                  marginBottom: 8,
                }}
              >
                {s.t}
              </div>
              <div style={{ fontSize: 14, color: theme.fgMute, lineHeight: 1.5 }}>{s.s}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
